export default __webpack_public_path__ + "static/media/Goat-Portal-logo-login.09d0af40.svg";